"use strict";Object.defineProperty(exports, "__esModule", {value: true});// src/contracts/pTON/v1/constants.ts
var pTON_OP_CODES = {
  DEPLOY_WALLET: 1824798067
};



exports.pTON_OP_CODES = pTON_OP_CODES;
//# sourceMappingURL=chunk-W75D6YWL.cjs.map